import type { OrderDetailResponseOrder } from './orderDetailResponseOrder';

export interface OrderDetailResponse {
  message?: string;
  order?: OrderDetailResponseOrder;
  success: boolean;
}
